import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Crop } from '../models/crop';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../@core/auth/auth.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CropService {

  protected basePath = '/';

  constructor(
    protected httpClient: HttpClient,
    private authService: AuthService
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }


  public getCrops(includeInactive: boolean = false): Observable<Crop[]> {

    let queryParameters = new HttpParams();

    queryParameters = queryParameters.set('includeInactive', String(includeInactive));

    return this.httpClient.get<Crop[]>(`${this.basePath}/api/crops`);
  }

  public putCrop(crop: Crop): Observable<Crop> {
    return this.httpClient.put<Crop>(`${this.basePath}/api/crops/${crop.id}`, crop);
  }

  public getCrop(id: number): Observable<Crop> {
    return this.httpClient.get<Crop>(`${this.basePath}/api/Crops/${id}`);
  }

  public deleteCrop(id: number) {
    return this.httpClient.delete(`${this.basePath}/api/Crops/${id}`);
  }

  public postCrop(crop: Crop): Observable<Crop[]> {
    return this.httpClient.post<Crop[]>(`${this.basePath}/api/crops`, crop);
  }

  public getCropsForTenant(tenantId: string): Observable<Crop[]> {
    return this.httpClient.get<Crop[]>(
      `${this.basePath}/api/Crops/tenant/${encodeURIComponent(tenantId)}`
    );
  }
}
